import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import PageBase from '@/components/common/Page'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import SEO from '@/components/head/seo'
import LD from '@/components/head/linking-data'
import LDEntity from '@/utils/linking-data'
import { layouts } from '@/utils/preset'
import Breadcrumb from '@/components/app/Breadcrumb.container'
import PageHead from '@/components/app/PageHead'
import FeatureOverview from '@/components/modules/Feature/Overview'
import FeatureMainList from '@/components/modules/Feature/MainList'
import FeatureSubList from '@/components/modules/Feature/SubList'
import ConversionLead from '@/components/modules/Conversion/Lead'

const FeatureIndexPage = props => (
  <StaticQuery
    query={query}
    render={data => {
      const siteMeta = data.site.siteMetadata
      const title = '搭載される機能'
      const description = 'FVP（フロントビジョンプランナー）では本格的なERPとして必要な機能を揃えつつ、中小企業向けにシンプルに提供しています。'
      return (
        <Root>
          <SEO location={props.location} title={title} description={description}/>
          <LD json={{
            '@type': 'WebPage',
            '@id': `${siteMeta.siteUrl}/feature/#webpage`,
            name: `${title} | ${siteMeta.title}`,
            description: description,
            url: `${siteMeta.siteUrl}/feature/`,
            inLanguage: 'ja',
            datePublished: '2019-11-10T10:00:00+09:00',
            dateModified: '2019-11-10T10:00:00+09:00',
            isPartOf: LDEntity.WebSite(siteMeta)
          }}/>
          <Breadcrumb path={props.location.pathname} />
          <Head>
            <PageHead
              title={title}
              description={description}
            />
          </Head>
          <Main>
            <FeatureOverview />
            <Border theme={props.theme} />
            <FeatureMainList />
            <Border theme={props.theme} />
            <FeatureSubList />
            <Border theme={props.theme} />
            <ConversionLead />
          </Main>
        </Root>
      )
    }}
  />
)

const Root = styled.div`
`

const Head = styled.div``

const Main = styled.div``

const Border = styled(layouts.components.FullWidth)`
  height: 1px;
  background-color: ${props => props.theme.line.base};
`

export default PageBase(ThemeConsumer(FeatureIndexPage))

const query = graphql`
  query FeatureIndexPageQuery {
    site {
      siteMetadata {
        siteUrl
        title
        description
        keywords
        image
        company {
          name
          logo
          siteUrl
        }
      }
    }
  }
`
